export default __webpack_public_path__ + "static/media/Consultoria-Informatica-EN.ce99c192.jpg";